export const MESSAGES: Messages = {
  CREATE: {
    SUCCESS: {
      variant: "default",
      description: "Download iniciado com sucesso.",
      duration: 5000,
      closeOnClick: true,
    },
    ERROR: {
      variant: "destructive",
      description: "Erro ao processar os arquivos.",
      duration: 5000,
      closeOnClick: true,
    },
  },
};
